import type { SVGProps } from 'react';
const SvgSingleBed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#single_bed_svg__a)">
      <path
        fill="currentColor"
        d="M20 12c0-1.1-.9-2-2-2V7c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L6 19h1l.67-2h8.67l.66 2h1l.67-2H20v-5Zm-4-2h-3V7h3v3ZM8 7h3v3H8V7Zm-2 5h12v3H6v-3Z"
      />
    </g>
    <defs>
      <clipPath id="single_bed_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSingleBed;
